import { MagicConfigMixin, configQuery } from '@gig/magic-common';
import { Mixins, Component } from 'vue-property-decorator';
import { USER_UPDATED } from '@gig/magic-messages';
import '../../services/notifications/notifications.constants.js';
import '../../services/notifications/notification.js';
import '../../services/notifications/notifications.service.js';
import { liveChatService } from '../../services/live-chat/live-chat.service.js';
import { init } from './liveagent-controller.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let LiveAgentComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.unsubscribe = null;
    this.initialised = false;
  }
  mounted() {
    this.unsubscribe = liveChatService.onLiveChatStateChange((isOpen) => __async(this, null, function* () {
      var _a;
      if (!isOpen) {
        return;
      }
      if (!this.initialised) {
        yield this.initialiseLiveAgent();
        this.initialised = true;
      }
      (_a = this.liveAgentController) == null ? void 0 : _a.openChat();
    }));
  }
  destroyed() {
    var _a, _b, _c;
    (_a = this.unsubscribe) == null ? void 0 : _a.call(this);
    (_b = this.languageSubscription) == null ? void 0 : _b.unsubscribe();
    (_c = this.loggedInSubscription) == null ? void 0 : _c.unsubscribe();
  }
  initialiseLiveAgent() {
    return __async(this, null, function* () {
      const liveChat = yield this.queryChatConfig();
      const { id, trackScriptUrl, chatId } = liveChat;
      yield this.loadLiveAgent(id, trackScriptUrl);
      this.updateUserDetails();
      yield this.createChatButton(chatId);
    });
  }
  queryChatConfig() {
    return configQuery("liveChat");
  }
  loadLiveAgent(id, trackScriptUrl) {
    return __async(this, null, function* () {
      this.liveAgentController = yield init({
        id,
        trackScriptUrl,
        onClose: () => {
          liveChatService.liveAgentClosed();
        }
      });
    });
  }
  updateUserDetails() {
    this.loggedInSubscription = window.eventBus.subscribe(USER_UPDATED, (event) => {
      this.liveAgentController.addUserDetails(event.payload);
    }, { replay: true });
  }
  createChatButton(chatId) {
    return this.liveAgentController.createButton(chatId);
  }
};
LiveAgentComponent = __decorateClass([
  Component({
    name: "liveagent"
  })
], LiveAgentComponent);

export default LiveAgentComponent;
